export default function businessCard(actions,clientInfo,images,settings,status){

    return {
        actions: actions,
        clientInfo: clientInfo,
        images: images,
        settings: settings,
        status: status
    }
    
}